"use client";

import { useRouter } from "next/navigation";
import { useLocalizedHref, useLogicalPathname } from "@/lib/l10n/providers";
import type { LegalNavFixture } from "../types";

interface LegalMobileNavProps {
  navigation: LegalNavFixture;
}

export function LegalMobileNav({ navigation }: LegalMobileNavProps) {
  const pathname = useLogicalPathname();
  const router = useRouter();
  const localizeHref = useLocalizedHref();

  return (
    <div className="relative mb-6 lg:hidden">
      <select
        value={pathname}
        onChange={(e) => router.push(localizeHref(e.target.value))}
        className="text-label-lg w-full cursor-pointer appearance-none rounded-lg border border-black/10 bg-white py-3 pl-4 pr-10 shadow-sm transition-colors hover:border-black/20 focus:border-black/30 focus:outline-none focus:ring-2 focus:ring-black/5"
        aria-label="Navigate legal pages"
      >
        {navigation.sections.map((section) => (
          <option key={section.url} value={section.url}>
            {section.title}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <svg
          className="h-4 w-4 text-black/40"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>
    </div>
  );
}
